import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { humanReadableDate } from '../../utils';
import { JobDetailsContainerStyled } from './style';

type JobInformationDataTypes = {
  createdAt: string;
  jobTitle: string;
  notes: string;
};

const JobInformation = ({
  createdAt,
  jobTitle,
  notes,
}: JobInformationDataTypes) => {
  return (
    <JobDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title"
        fontColor="secondary"
        strong
      >
        JOB INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Created At: </Typography>
          <Typography className="value">
            {humanReadableDate(createdAt)}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Job Title: </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Notes :</Typography>
          <Typography className="value">{notes}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </JobDetailsContainerStyled>
  );
};
export default JobInformation;
